import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

export const useManageChargeDetail = () => {
  const queryClient = useQueryClient();
  const { mutateAsync, isPending } = useMutation('manageChargeCategory', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['chargeSlab'] });
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });
  return { mutateAsync, isPending };
};
